import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure-theme.svg'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import React, { useEffect } from 'react'
import * as yup from 'yup'
import rem from '@/utils/rem'
import Button from '@/components/Button/index'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'

const validationSchema = yup.object({
	referenceNumber: yup
		.string('Enter your Reference Number')
		.required('Reference Number is required')
		.test('reference-validation','Input field allows only Alphanumeric, Hyphen or Space as characters.', function(value){
			let regex = /^[\w\-\s]+$/
			return regex.test(value)
		})
		.min(8, 'Reference Number should be minimum of 8 characters length')
		.max(32, 'Reference Number should be of 32 characters length'),
})

export default function UpdatePackageReferenceNumberModal({ visible, close, handleSubmit, type, data }) {
	const { t } = useTranslation()
	const formik = useFormik({
		validationSchema: validationSchema,
		validateOnMount: true,
		onSubmit: async (data) => {
			handleSubmit(data.referenceNumber)
		},
		initialValues: {
			referenceNumber: '',
		},
	})

	useEffect(() => {
		formik.setFieldValue('referenceNumber', "")
	}, [data?.referenceNumber])

	const onSubmitUpdateReferece = (data) =>{
		handleSubmit(data)
		formik.resetForm({values:""})
	}

	const handleClose = ()=>{
		close()
		formik.resetForm({values:""})
	}

	return (
		<Modal visible={visible} variant='medium'  close={handleClose}>
			<CardConfigure >
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
					<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon--package'}>
										<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
										{type === 'Add' ? "Add Reference ID" : "Update Reference ID"}
										</div>
									</div>
								</div>
							</div>

					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="package-reference-receipient__input">
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
								{type === 'Add' ? "Sender's Reference ID" : "Current Reference ID"}
							</span>
							<input
								type="text"
								name="referenceNumber"
								value={type === 'Update' ? data?.referenceNumber : data?.receivedReferenceNumber}
								placeholder="Sender’s Reference ID"
								disabled
								style={{ marginBottom: 16 }}
							/>
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span" style={{ marginTop: rem(16) }}>
								{type === 'Add' ? "Your Reference ID" : "New Reference ID"}
							</span>
							<input
								type="text"
								name="referenceNumber"
								value={formik.values.referenceNumber}
								onChange={formik.handleChange}
								placeholder="Type here"
								maxLength={32}
								onBlur={formik.handleBlur}
							/>
							{formik.errors["referenceNumber"] && formik.dirty && <div className="error-message">{formik.errors['referenceNumber']}</div>  }
							<div className="package-reference-create__input-description">
								{t('referenceNumberDescription')}
							</div>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button text="Cancel" submit={handleClose} ghost />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text={type === 'Add' ? "Confirm" : "Update"}
							submit={() => { onSubmitUpdateReferece(formik.values.referenceNumber) }}
							disabled={!(formik.isValid && formik.dirty)}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
